import { DOMHitTest } from "../../dom-tools/DOMHitTest";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { OnClick, OnKeyDown, OnMouseDown, OnMouseUp } from "../../dom-tools/EventListeners";
import { EditingKeys } from "../../dom-tools/keyboard-events/EditingKeys";
import { WhiteSpaceKeys } from "../../dom-tools/keyboard-events/WhiteSpaceKeys";
import { Mouse } from "../../dragging/PointerData";
import { Caret } from "./Caret";
import { Line } from "./Line";
import { TextEditor } from "./TextEditor";
import { TextEditorElementKeyEvent } from "./TextEditorElementKeyEvent";
import { TextEditorEvent } from "./TextEditorEvent";

export class TextEditorElement
{
  static readonly type   = new ElementType<HTMLElement>( "text--editor" );
  static readonly offset = new ElementType<HTMLElement>( "text--editor--offset" );
  static readonly linesContainer  = new ElementType<HTMLElement>( "text--editor--lines--container" );
  static readonly line   = new ElementType<HTMLElement>( "text--editor--line" );
  static readonly character   = new ElementType<HTMLElement>( "text--editor--character" );
  static readonly lineID = new ElementAttribute( "line--id" );
  static readonly textFocus = new ElementType<HTMLElement>( "text--editor--text--focus")

  static applyOnDocument()
  {
    TextEditorElement.type.forAllInDoc( e => TextEditorElement.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let editorElement = new TextEditorElement();

    editorElement.setElement( e );

    editorElement._editor.addText( "" );
    editorElement._editor.setSelection( Caret.before( 0, 0 ) ); 
    
  }

  
  _editor:TextEditor = new TextEditor();
  _textFocus:HTMLElement;

  _element:HTMLElement;
  _offset:HTMLElement;
  _linesContainer:HTMLElement;
  
  _lines:HTMLElement[] = [];
  _focusWithTextArea:boolean = true;

  setElement( e:Element )
  {
    this._element        = e as HTMLElement;
    this._offset         = TextEditorElement.offset.query( e );
    this._linesContainer = TextEditorElement.linesContainer.query( e ) ;
    this._textFocus      = TextEditorElement.textFocus.query( e );

    OnKeyDown.add( this._textFocus, ( e )=> this.onKeyDown( TextEditorElementKeyEvent.from( e ) ) ); 

    OnClick.add( 
      this._element, 
      ()=> 
      {
        if ( this._textFocus === document.activeElement )
        {
          return;
        } 

        this.focus()
      } 
    );

    OnMouseDown.add( 
      this._element, ( e:MouseEvent )=>
      {
        console.log( e, this._lines.length );

        let pointer = DOMHitTest.getPointerPosition( e );

        for ( let i = 0; i < this._lines.length; i++ )
        {
          let childNodes = this._lines[ i ].childNodes;

          for ( let j = 0; j < childNodes.length; j++ )
          {
            let pageRect = DOMHitTest.getPageBox( childNodes.item( j ) as Element );
            let isOver = pageRect.containsPoint( pointer );

            console.log( i, j, isOver, pageRect, pointer  );

            if ( isOver )
            {
            
              this._editor.setSelection( Caret.after( i, j ) );

              return;
            }
          }
        }

      }
    );


    this._editor.onChange.addListener( te => this._synchronizeView( te ) );
    
  }

  onKeyDown( ke: TextEditorElementKeyEvent)
  {
    console.log( ke );

    if ( ke.hasText )
    {
      this._editor.addText( ke.keyText );
    }
    else if ( EditingKeys.Backspace === ke.key )
    {
      this._editor.removePrevious();
    }
    
  }

  _synchronizeView( changeEvent:TextEditorEvent )
  {
    console.log( changeEvent );

    this._linesContainer.innerHTML = "";
    let lineElements = this._editor.lines.map( l => this._createLineElement( l ) );

    this._lines = [];

    lineElements.forEach( 
      l => 
      { 
        this._linesContainer.appendChild( l ); 
        this._linesContainer.appendChild( ElementType.break.create() ); 

        this._lines.push( l );
      }
    );

  }

  _createLineElement( line:Line ) 
  {
    let lineElement = TextEditorElement.line.create();
    
    for ( let i = 0; i < line.content.length; i++ )
    {
      let characterContent = line.content[ i ];
      let characterElement = TextEditorElement.character.create( characterContent );

      lineElement.appendChild( characterElement );
    }

    return lineElement;

  }

  focus()
  {
    console.log( "FOCUS EDITOR" );

    if ( this._focusWithTextArea )
    {
      console.log( "FOCUS EDITOR", this._textFocus );
      this._textFocus.focus();
    }
  }
  

}